import React from "react";

const Component = props => {
  return <>{props.children}</>;
};

export default Component;
